// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envType: 'dev',

  externalUrls: {
    user: {
      baseUrl: 'https://lumconnectdevusermanagement.azurewebsites.net/v1/',
    },
    product: {
      baseUrl: 'https://lumconnectdevproductmanagement.azurewebsites.net/v1/',
    },
    system_integration: {
      baseUrl: 'https://nox-be-dev.azurewebsites.net/v1/nox/si',
      loginUrl: 'https://devuserserviceazure.azurewebsites.net/v1/users/login',
    },
    holium: {
      baseUrl: 'https://www.holmiumtechnologies.com/rms/api/dashboard/rooftop/default',
      loginUrl: "https://www.holmiumtechnologies.com/rms/api/auth/login"
    }, 
  },

  iam:{
    baseUrl:'https://apim-luminous-prod.azure-api.net/iam-dev',
    tenantId: 'f47ac10b-58cc-4372-a567-0e02b2c3d479'
  },
  users: {
    baseUrl: 'https://apim-luminous-prod.azure-api.net/user-dev'
  }
};
